import { useAppDispatch, useAppSelector } from "./hooks";
import {
  getAllReportsWithNotesAsync,
  getSpecificReportNotesAsync,
  selectNotesStatus,
  addReportNoteAsync,
  removeReportNoteAsync,
  updateReportNoteAsync,
} from "../features/reports/reportsSlice";
import { CombinedNoteParams } from "../features/reports/reportTypes";

/* GetAllReportsWithNotesDispatch */
const useGetAllReportsWithNotesDispatch = () => {
  const dispatch = useAppDispatch();
  const notesListStatus = useAppSelector(selectNotesStatus);

  const getAllReportsWithNotes = () => {
    if (notesListStatus === "loading") return;
    dispatch(getAllReportsWithNotesAsync());
  };

  return getAllReportsWithNotes;
};

/* GetSpecificReportNotesDispatch */
const useGetSpecificReportNotesDispatch = () => {
  const dispatch = useAppDispatch();
  const noteStatus = useAppSelector(selectNotesStatus);

  const getSpecificReportNotes = (reportNote: CombinedNoteParams) => {
    if (noteStatus === "loading") return;
    dispatch(getSpecificReportNotesAsync(reportNote));
  };

  return getSpecificReportNotes;
};

/* AddReportNoteDispatch */
const useAddReportNoteDispatch = () => {
  const dispatch = useAppDispatch();
  const noteStatus = useAppSelector(selectNotesStatus);

  const addReportNote = (reportNote: CombinedNoteParams) => {
    if (noteStatus === "loading") return;
    dispatch(addReportNoteAsync(reportNote)).then(action => {
      if (addReportNoteAsync.fulfilled.match(action)) {
        dispatch(getSpecificReportNotesAsync(reportNote));
        dispatch(getAllReportsWithNotesAsync());
      }
    });
  };

  return addReportNote;
};

/* RemoveReportNoteDispatch */
const useRemoveReportNoteDispatch = () => {
  const dispatch = useAppDispatch();
  const noteStatus = useAppSelector(selectNotesStatus);

  const removeReportNote = (reportNote: { reportNoteId: number }) => {
    if (noteStatus === "loading") return;
    dispatch(removeReportNoteAsync(reportNote));
  };

  return removeReportNote;
};

/* UpdateReportNoteDispatch */
const useUpdateReportNoteDispatch = () => {
  const dispatch = useAppDispatch();
  const noteStatus = useAppSelector(selectNotesStatus);

  const updateReportNote = (reportNote: {
    reportNoteId: number;
    note: string;
  }) => {
    if (noteStatus === "loading") return;
    dispatch(updateReportNoteAsync(reportNote));
  };

  return updateReportNote;
};

export {
  useGetAllReportsWithNotesDispatch,
  useGetSpecificReportNotesDispatch,
  useAddReportNoteDispatch,
  useRemoveReportNoteDispatch,
  useUpdateReportNoteDispatch,
};
